/* Intercepts requests to check for 401 status code */

import Auth from '../auth/auth';

export const authInterceptor = ({ dispatch }) => next => action => {    
    if (action.type === '@@query/REQUEST_FAILURE' && action.status === 401) {
        let auth = new Auth();
        auth.logout(auth.getCurrentViewPath());
    } else {
        return next(action);
    }
};



// WEBPACK FOOTER //
// ./src/middleware/authInterceptor.tsx